import { Formik } from "formik";
import React, { useCallback, useEffect, useState } from "react";
import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import BasicSelect from "../BasicSelect";
import LoadButton from "../LoadButton";
import { jsonSort, teamUsers } from "../../utils/commonMethods";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setQuery, clearQuery } from "../../store/reducers/query";
import {
  isAdmin,
  isAdminSrmanager,
  leadType,
  status,
} from "../../utils/menuItems";
import Apis from "../../utils/apis";
import dayjs from "dayjs";
import CustomRadio from "../CustomRadio";
import MultiSelect from "../MultiSelect";
import { useGetProjectsListQuery } from "../../store/services/project";
import { useLazyGetLeadQuestionFiltersQuery } from "../../store/services/leads";
import { myConsole } from "../../hooks/useConsole";

const LeadAdForm = ({ handleClose, users, leadCatagory = "lead" }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { auth } = useSelector((state) => state.auth);
  // const { users } = useSelector((state) => state.users);
  const { teams } = useSelector((state) => state.teams);

  const { data: projectsData, isFetching: isFetchingProjects } =
    useGetProjectsListQuery({
      page: 1,
      limit: 1000,
      pagination: false,
      includeInactive: true,
    });

  const projectList = (projectsData?.data || []).map((itm) => ({
    label: itm?.projectName,
    value: itm?._id?.toString(),
  }));

  const { query, type: queryType } = useSelector((state) => state.query);
  const filterQuery = queryType === leadCatagory ? query : {};
  const agent = auth?.role === "agent";
  const teamLeadAgent = auth?.role === "team_lead" || auth?.role === "agent";
  const AMTeamLeadAgent = teamLeadAgent || auth?.role === "assistant_manager";
  const ManagerAMTeamLeadAgent = AMTeamLeadAgent || auth?.role === "manager";
  const SrmManagerAMTeamLeadAgent =
    ManagerAMTeamLeadAgent || auth?.role === "sr_manager";

  const [values, setValues] = useState({
    // type: leadCatagory,
    status: filterQuery?.status ? filterQuery?.status : [],
    startDate: filterQuery?.startDate
      ? dayjs(filterQuery?.startDate).startOf("day")
      : null,
    endDate: filterQuery?.endDate
      ? dayjs(filterQuery?.endDate).endOf("day")
      : dayjs(Date.now()),
    srManager: Array.isArray(filterQuery?.srManager)
      ? filterQuery.srManager
      : filterQuery?.srManager
        ? [filterQuery.srManager]
        : [],
    manager: filterQuery?.manager ? filterQuery?.manager : [],
    assistantManager: filterQuery?.assistantManager ?? [],
    teamLead: filterQuery?.teamLead ? filterQuery?.teamLead : [],
    agent: filterQuery?.agent ? filterQuery?.agent : [],
    individual: filterQuery?.individual,
    personalLeads: filterQuery?.personalLeads || "include",
    duplicateLeads: filterQuery?.duplicateLeads || "include",
    exclude: {
      status: filterQuery?.exclude?.status ?? false,
      projectId: filterQuery?.exclude?.projectId ?? false,
      source: filterQuery?.exclude?.source ?? false,
      srManager: filterQuery?.exclude?.srManager ?? false,
      manager: filterQuery?.exclude?.manager ?? false,
      assistantManager: filterQuery?.exclude?.assistantManager ?? false,
      teamLead: filterQuery?.exclude?.teamLead ?? false,
      agent: filterQuery?.exclude?.agent ?? false,
    },
    teamId: Array.isArray(filterQuery?.teamId)
      ? filterQuery.teamId
      : filterQuery?.teamId
        ? [filterQuery.teamId]
        : [],
    dateKey: filterQuery?.dateKey ?? "createdAt",
    projectId: filterQuery?.projectId ? filterQuery?.projectId : "",
    source: filterQuery?.source ? filterQuery?.source : "",
    questionFilters: Array.isArray(filterQuery?.questionFilters)
      ? filterQuery.questionFilters
      : [],
  });
  const [questionProjectId, setQuestionProjectId] = useState(values.projectId);
  const [questionOptions, setQuestionOptions] = useState([]);
  const [
    loadQuestionFilters,
    { isFetching: isFetchingQuestions, isError: questionError },
  ] = useLazyGetLeadQuestionFiltersQuery();

  useEffect(() => {
    if (!questionProjectId) {
      setQuestionOptions([]);
      return;
    }
    loadQuestionFilters(questionProjectId)
      .unwrap()
      .then((response) => setQuestionOptions(response?.data || []))
      .catch(() => setQuestionOptions([]));
  }, [questionProjectId, loadQuestionFilters]);

  // const filterUsers = useCallback(
  //   (value) => {
  //     return jsonSort(
  //       teamUsers(teams, users)?.filter((user) =>
  //         user.role === value ? true : false
  //       ),
  //       "name",
  //       true
  //     ).map((user) => ({ value: user._id, label: user.name }));
  //   },
  //   [teams, users]
  // );

  return (
    <Formik
      initialValues={values}
      onSubmit={async (values) => {
        setLoading(true);

        const payload = {
          ...values,
          startDate: values.startDate
            ? dayjs(values.startDate).format("YYYY-MM-DD")
            : undefined,
          endDate: values.endDate
            ? dayjs(values.endDate).format("YYYY-MM-DD")
            : undefined,
        };

        // myConsole("Full payload:", payload);

        try {
          dispatch(
            setQuery({
              type: leadCatagory,
              values: payload,
            }),
          );

          if (leadCatagory === "lead") {
            navigate(`/leads?type=lead`);
          } else {
            navigate(`/callingData?type=calling_data`);
          }
          handleClose();
        } catch (err) {
          console.log("err", err);
        }
        setLoading(false);
      }}
    >
      {({ values, handleChange, setFieldValue, handleSubmit }) => (
        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            minHeight: 0,
          }}
        >
          <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", pr: 1, pb: 3 }}>
            <Grid container rowSpacing={3} columnSpacing={3} mt={0}>
              {!["agent"].includes(auth?.role) && (
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      mb: 1,
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    Teams Option
                  </Typography>
                  <CustomRadio
                    items={[
                      { value: true, label: "My Leads" },
                      { value: false, label: "Teams Lead" },
                    ]}
                    value={
                      values.individual === true || values.individual === "true"
                        ? true
                        : false
                    }
                    handleChange={(e) =>
                      setFieldValue("individual", e.target.value === "true")
                    }
                    name={"individual"}
                    size={"small"}
                    row
                  />
                </Grid>
              )}

              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 18,
                    mb: 1,
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  Personal Leads
                </Typography>
                <CustomRadio
                  items={[
                    { value: "include", label: "Include" },
                    { value: "exclude", label: "Exclude" },
                    { value: "only_personal", label: "Only Personal" },
                  ]}
                  value={values.personalLeads}
                  handleChange={(e) =>
                    setFieldValue("personalLeads", e.target.value)
                  }
                  name={"personalLeads"}
                  size={"small"}
                  row
                />
              </Grid>

              <Grid item xs={12}>
                <Typography
                  sx={{
                    fontSize: 18,
                    mb: 1,
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  Duplicate Leads
                </Typography>
                <CustomRadio
                  items={[
                    { value: "include", label: "Include" },
                    { value: "exclude", label: "Exclude" },
                    { value: "only_duplicates", label: "Only Duplicates" },
                  ]}
                  value={values.duplicateLeads}
                  handleChange={(e) =>
                    setFieldValue("duplicateLeads", e.target.value)
                  }
                  name="duplicateLeads"
                  size="small"
                  row
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Typography
                  sx={{
                    fontSize: 18,
                    mb: 1,
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  Date Filter By
                </Typography>
                <BasicSelect
                  value={values.dateKey}
                  name={"dateKey"}
                  size="small"
                  handleChange={handleChange}
                  items={[
                    { label: "Creation Time", value: "createdAt" },
                    { label: "Updation Time", value: "updatedAt" },
                    { label: "Assign Time", value: "assignedAt" },
                  ]}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography
                  sx={{
                    fontSize: 18,
                    mb: 1,
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  Start Date
                </Typography>
                <DatePicker
                  value={values.startDate}
                  onChange={(newValue) => setFieldValue("startDate", newValue)}
                  sx={{ width: "100%" }}
                  placeholder="start"
                  format="DD/MM/YYYY"
                  slotProps={{
                    field: {
                      size: "small",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography
                  sx={{
                    fontSize: 18,
                    mb: 1,
                    fontWeight: 500,
                    color: "#000000",
                  }}
                >
                  End Date
                </Typography>
                <DatePicker
                  value={values.endDate}
                  onChange={(newValue) => setFieldValue("endDate", newValue)}
                  sx={{ width: "100%" }}
                  placeholder="start"
                  format="DD/MM/YYYY"
                  slotProps={{
                    field: {
                      size: "small",
                    },
                  }}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
                  <Typography sx={{ fontSize: 18, mb: 1, fontWeight: 500, color: "#000000" }}>
                    Status
                  </Typography>
                  <FormControlLabel
                    label="Exclude"
                    control={
                      <Checkbox
                        size="small"
                        inputProps={{ "aria-label": "Exclude status" }}
                        checked={values.exclude.status}
                        onChange={(event) => {
                          setFieldValue("exclude.status", event.target.checked);
                        }}
                      />
                    }
                  />
                </Stack>
                <MultiSelect
                  value={values.status}
                  name={"status"}
                  // size="small"
                  handleChange={setFieldValue}
                  items={[{ value: "new", label: "New" }, ...status]}
                />
                {/* <BasicSelect
                value={values.status}
                name={"status"}
                size="small"
                handleChange={handleChange}
                items={[{ value: "new", label: "New" }, ...status]}
              /> */}
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
                  <Typography sx={{ fontSize: 18, mb: 1, fontWeight: 500, color: "#000000" }}>
                    Project
                  </Typography>
                  <FormControlLabel
                    label="Exclude"
                    control={
                      <Checkbox
                        size="small"
                        inputProps={{ "aria-label": "Exclude project" }}
                        checked={values.exclude.projectId}
                        onChange={(event) => {
                          setFieldValue("exclude.projectId", event.target.checked);
                          if (event.target.checked) setFieldValue("questionFilters", []);
                        }}
                      />
                    }
                  />
                </Stack>
                <BasicSelect
                  value={values.projectId}
                  name={"projectId"}
                  size="small"
                  handleChange={(event) => {
                    handleChange(event);
                    setFieldValue("questionFilters", []);
                    setQuestionProjectId(event.target.value);
                  }}
                  items={projectList}
                  canSearch
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <Stack direction="row" sx={{ justifyContent: "space-between", alignItems: "center" }}>
                  <Typography sx={{ fontSize: 18, mb: 1, fontWeight: 500, color: "#000000" }}>
                    Source
                  </Typography>
                  <FormControlLabel
                    label="Exclude"
                    control={
                      <Checkbox
                        size="small"
                        inputProps={{ "aria-label": "Exclude source" }}
                        checked={values.exclude.source}
                        onChange={(event) => {
                          setFieldValue("exclude.source", event.target.checked);
                        }}
                      />
                    }
                  />
                </Stack>
                <TextField
                  name="source"
                  value={values.source}
                  onChange={handleChange}
                  fullWidth
                  size="small"
                />
              </Grid>

              {values.projectId && !values.exclude.projectId && (
                <Grid item xs={12}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      mb: 1,
                      fontWeight: 500,
                      color: "#000000",
                    }}
                  >
                    Campaign Questions
                  </Typography>
                  {isFetchingQuestions && (
                    <Typography sx={{ color: "#6b7280", fontSize: 14 }}>
                      Loading questions...
                    </Typography>
                  )}
                  {!isFetchingQuestions && questionError && (
                    <Typography sx={{ color: "#b91c1c", fontSize: 14 }}>
                      Unable to load campaign questions.
                    </Typography>
                  )}
                  {!isFetchingQuestions &&
                    !questionError &&
                    questionOptions.length === 0 && (
                      <Typography sx={{ color: "#6b7280", fontSize: 14 }}>
                        No submitted campaign questions are available for this
                        project.
                      </Typography>
                    )}
                  <Grid container spacing={3}>
                    {questionOptions.map((question) => {
                      const selectedQuestion = (
                        values.questionFilters || []
                      ).find((filter) => filter.key === question.key);
                      return (
                        <Grid item xs={12} sm={6} md={4} key={question.key}>
                          <MultiSelect
                            value={selectedQuestion?.answers || []}
                            name={question.key}
                            title={question.label}
                            canSearch
                            items={question.answers}
                            handleChange={(_, answers) => {
                              const nextFilters = (
                                values.questionFilters || []
                              ).filter((filter) => filter.key !== question.key);
                              if (answers.length) {
                                nextFilters.push({
                                  key: question.key,
                                  label: question.label,
                                  answers,
                                });
                              }
                              setFieldValue("questionFilters", nextFilters);
                            }}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                </Grid>
              )}

              {/* {console.log("207", values.individual)} */}
              {(!values.individual ||
                values.individual === false ||
                values.individual === "false") && (
                <>
                  {isAdminSrmanager.includes(auth?.role) && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Stack
                        direction="row"
                        spacing={5}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 18,
                            mb: 1,
                            fontWeight: 500,
                            color: "#000000",
                          }}
                        >
                          PNL
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("exclude", {
                                  ...(values.exclude || {}),
                                  srManager: e.target.checked,
                                })
                              }
                              checked={values.exclude.srManager}
                            />
                          }
                          label="Exclude"
                        />
                      </Stack>
                      <MultiSelect
                        value={values.srManager}
                        name={"srManager"}
                        handleChange={setFieldValue}
                        items={users?.["sr_manager"]}
                        canSearch
                      />
                    </Grid>
                  )}

                  {!ManagerAMTeamLeadAgent && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Stack
                        direction="row"
                        spacing={5}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 18,
                            mb: 1,
                            fontWeight: 500,
                            color: "#000000",
                          }}
                        >
                          Team Manager
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("exclude", {
                                  ...(values.exclude || {}),
                                  manager: e.target.checked,
                                })
                              }
                              checked={values.exclude.manager}
                            />
                          }
                          label="Exclude"
                        />
                      </Stack>
                      <MultiSelect
                        value={values.manager}
                        name={"manager"}
                        // size="small"
                        handleChange={setFieldValue}
                        items={users?.["manager"]}
                        canSearch
                      />
                    </Grid>
                  )}

                  {!AMTeamLeadAgent && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Stack
                        direction="row"
                        spacing={5}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 18,
                            mb: 1,
                            fontWeight: 500,
                            color: "#000000",
                          }}
                        >
                          Assistant Manager
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("exclude", {
                                  ...(values.exclude || {}),
                                  assistantManager: e.target.checked,
                                })
                              }
                              checked={values.exclude.assistantManager}
                            />
                          }
                          label="Exclude"
                        />
                      </Stack>
                      <MultiSelect
                        value={values.assistantManager}
                        name={"assistantManager"}
                        // size="small"
                        handleChange={setFieldValue}
                        items={users?.["assistant_manager"]}
                        canSearch
                      />
                    </Grid>
                  )}

                  {!teamLeadAgent && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Stack
                        direction="row"
                        spacing={5}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 18,
                            mb: 1,
                            fontWeight: 500,
                            color: "#000000",
                          }}
                        >
                          Team Lead
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("exclude", {
                                  ...(values.exclude || {}),
                                  teamLead: e.target.checked,
                                })
                              }
                              checked={values.exclude.teamLead}
                            />
                          }
                          label="Exclude"
                        />
                      </Stack>
                      <MultiSelect
                        value={values.teamLead}
                        name={"teamLead"}
                        canSearch
                        // size="small"
                        handleChange={setFieldValue}
                        items={users?.["team_lead"]}
                      />
                    </Grid>
                  )}
                  {!agent && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Stack
                        direction="row"
                        spacing={5}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 18,
                            mb: 1,
                            fontWeight: 500,
                            color: "#000000",
                          }}
                        >
                          Agents
                        </Typography>
                        <FormControlLabel
                          control={
                            <Checkbox
                              size="12px"
                              onChange={(e) =>
                                setFieldValue("exclude", {
                                  ...(values.exclude || {}),
                                  agent: e.target.checked,
                                })
                              }
                              checked={values.exclude.agent}
                            />
                          }
                          label="Exclude"
                        />
                      </Stack>
                      <MultiSelect
                        value={values.agent}
                        name={"agent"}
                        // size="small"
                        handleChange={setFieldValue}
                        items={users?.["agent"]}
                        canSearch
                      />
                    </Grid>
                  )}

                  {!agent && (
                    <Grid item xs={12} sm={6} md={4}>
                      <Stack
                        direction="row"
                        spacing={5}
                        sx={{
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          sx={{
                            fontSize: 18,
                            mb: 1,
                            fontWeight: 500,
                            color: "#000000",
                          }}
                        >
                          Team
                        </Typography>
                      </Stack>
                      <MultiSelect
                        value={values.teamId}
                        name={"teamId"}
                        canSearch
                        handleChange={setFieldValue}
                        items={teams.map((itm) => ({
                          value: itm._id,
                          label: itm.name,
                        }))}
                      />
                    </Grid>
                  )}
                </>
              )}
            </Grid>
          </Box>
          <Box
            sx={{
              flexShrink: 0,
              py: 1.5,
              bgcolor: "#fff",
              borderTop: "1px solid #e5e7eb",
            }}
          >
            <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
              <LoadButton
                loading={loading}
                type="submit"
                variant="contained"
                color="custom"
                sx={{ width: "120px", marginBottom: 0 }}
              >
                Apply
              </LoadButton>
              {queryType === leadCatagory && query && (
                <LoadButton
                  type="button"
                  variant="outlined"
                  color="error"
                  sx={{ width: "140px", marginBottom: 0 }}
                  onClick={() => {
                    dispatch(clearQuery());
                    handleClose();
                  }}
                >
                  Clear Search
                </LoadButton>
              )}
            </Box>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default LeadAdForm;
